import {
    buildStoryMapCardLink,
    isMongoObjectId,
} from '../../storyMap.service'
import {
    flattenSteps,
    parseJourneyLabel,
    parseStepLabel,
} from '../ProjectStoryMapBoard/utils'

const cleanPart = (part) => String(part || '').trim()

/**
 * Flatten a story-map board into linkable Story / Step items for the # picker.
 */
export const buildStoryMapLinkCatalog = ({ board, projectId } = {}) => {
    const storyMapId = board?.id
    if (!projectId || !storyMapId || !isMongoObjectId(storyMapId)) return []

    const items = []
    const stepsById = new Map()

    for (const journey of board.journeys || []) {
        const journeyLabel = cleanPart(parseJourneyLabel(journey?.title || ''))
        for (const step of journey.steps || []) {
            if (!isMongoObjectId(step?.id)) continue
            const stepTitle = cleanPart(parseStepLabel(step?.title || '').name)
            stepsById.set(String(step.id), {
                journeyLabel,
                stepTitle,
            })

            const href = buildStoryMapCardLink({
                projectId,
                storyMapId,
                cardType: 'step',
                cardId: step.id,
            })
            if (!href) continue
            items.push({
                id: String(step.id),
                kind: 'step',
                title: stepTitle || 'Untitled step',
                // Step breadcrumb: journey only
                crumbs: [journeyLabel].filter(Boolean),
                href,
            })
        }
    }

    if (stepsById.size === 0) {
        for (const step of flattenSteps(board.journeys || [])) {
            if (!isMongoObjectId(step?.id)) continue
            stepsById.set(String(step.id), {
                journeyLabel: cleanPart(
                    parseJourneyLabel(step.journeyTitle || '')
                ),
                stepTitle: cleanPart(parseStepLabel(step?.title || '').name),
            })
        }
    }

    const seenStories = new Set()
    for (const release of board.releases || []) {
        for (const story of release.stories || []) {
            const id = String(story?.id ?? '')
            if (!id || seenStories.has(id) || !isMongoObjectId(id)) continue
            seenStories.add(id)

            const href = buildStoryMapCardLink({
                projectId,
                storyMapId,
                cardType: 'story',
                cardId: id,
            })
            if (!href) continue

            const stepMeta = stepsById.get(String(story.stepId))
            // Story breadcrumb: Journey › Step (no release/Index label)
            const crumbs = [
                stepMeta?.journeyLabel,
                stepMeta?.stepTitle,
            ].filter(Boolean)

            items.push({
                id,
                kind: 'story',
                title: story?.title || 'Untitled story',
                crumbs,
                href,
            })
        }
    }

    return items
}
